// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jj-0";
export var actionModalContentContainer = "_jj-1";
export var createTagButton = "_jj-2";
export var footerContainer = "_jj-7";
export var fullWidthDivider = "_jj-3";
export var hasCreateTagButton = "_jj-4";
export var noCreateTagButton = "_jj-5";
export var tagsContainer = "_jj-6";
export var tagsModalContentContainer = "_jj-8";